const LOGIN_KEY_ENV_NAME = 'REACT_APP_LOGIN_ENCRYPTION_KEY';
const IV_LENGTH = 12;

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = '';

  for (let index = 0; index < bytes.length; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }

  return window.btoa(binary);
};

export const encryptLoginPassword = async (password) => {
  const passphrase = process.env[LOGIN_KEY_ENV_NAME];

  if (!passphrase) {
    throw new Error(`${LOGIN_KEY_ENV_NAME} is not configured`);
  }

  const keyBytes = await window.crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(passphrase)
  );
  const key = await window.crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-GCM' },
    false,
    ['encrypt']
  );
  const iv = window.crypto.getRandomValues(new Uint8Array(IV_LENGTH));
  const encryptedPassword = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    new TextEncoder().encode(password)
  );

  const payload = new Uint8Array(iv.length + encryptedPassword.byteLength);
  payload.set(iv, 0);
  payload.set(new Uint8Array(encryptedPassword), iv.length);

  return arrayBufferToBase64(payload.buffer);
};
